/* eslint-disable import/no-anonymous-default-export */
export default {
  mutation: `mutation initNewBlocks($blocks: AWSJSON) {
        initNewBlocks(blocks: $blocks)
    }`,
};
